export default __webpack_public_path__ + "af1547fd2a4f0637b14c97b9a00037be.png";